import { Tag } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { Autocomplete } from '../../../../common/components/autocomplete';
import { IAppState, Dispatch } from '../../../../common/state';
import { EBuildingType } from '../../../../json_query';
import { BuildingTypeName } from '../../../../types/commercial';
import { buildingTypeAdded, buildingTypeRemoved } from '../../../state/advanced/building_type';
import { InlineParam, Row } from '../markup';

const style = require('./building_type.css');

const disallowedTypes: EBuildingType[] = [
  EBuildingType.PropertyComplex,
  EBuildingType.ManufactureBuilding,
  EBuildingType.ModularBuilding,
  EBuildingType.FreeBuilding,
  EBuildingType.OfficeWarehouse,
];

interface IBuildingTypeProps {
  buildingTypes: EBuildingType[];
  onBuldingTypeAdded(value: EBuildingType): void;
  onBuldingTypeRemoved(value: EBuildingType): void;
}

const buildingType: React.StatelessComponent<IBuildingTypeProps> = ({
  buildingTypes,
  onBuldingTypeAdded,
  onBuldingTypeRemoved,
}) => (
  <Row title="Тип здания">
    <InlineParam>
      <div className={style['input']}>
        <Autocomplete
          placeholder="Выберите тип здания"
          suggestions={Array.from(BuildingTypeName)
            .filter(([key]) => !disallowedTypes.includes(key) && !buildingTypes.includes(key))
            .map(([key, value]) => ({
              label: value,
              value: key,
            }))}
          onSelect={(suggestion: { label: string; value: EBuildingType }) => onBuldingTypeAdded(suggestion.value)}
        />
      </div>
      {buildingTypes.length > 0 && (
        <div>
          {buildingTypes.map(type => (
            <Tag key={`buildingType-${type}`} tagStyles={style['tag']} onDeleteClick={() => onBuldingTypeRemoved(type)}>
              {BuildingTypeName.get(type)}
            </Tag>
          ))}
        </div>
      )}
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    buildingTypes: (state.filters.jsonQuery.building_type2 && state.filters.jsonQuery.building_type2.value) || [],
  }),
  (dispatch: Dispatch) => ({
    onBuldingTypeAdded: (value: EBuildingType) => {
      dispatch(buildingTypeAdded(value));
    },
    onBuldingTypeRemoved: (value: EBuildingType) => {
      dispatch(buildingTypeRemoved(value));
    },
  }),
)(buildingType);
